import { Box, Heading, IBasicUserType } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledAvatar = styled.div<IBasicUserType>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem('74px')};
  height: ${rem('74px')};
  border-radius: 50%;
  border: 2px solid ${({ theme, user }) => user && theme.colors[user].main};
  padding: ${rem('3px')};
  object-fit: cover;
  z-index: -1;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    width: ${rem('88px')};
    height: ${rem('88px')};
  }
`;

export const StyledBox = styled(Box)`
  padding-top: ${rem('80px')};
  flex-wrap: nowrap;
`;

export const StyledButton = styled.button<IBasicUserType>`
  display: flex;
  padding: 0;
  color: ${({ theme, user }) => user && theme.colors[user].main};
  font-size: ${rem('16px')};
  font-weight: 700;
  letter-spacing: ${rem('0.48px')};
  text-decoration: underline;
  background-color: transparent;
  border: none;
  cursor: pointer;
  appearance: none;
`;

export const StyledInput = styled.input`
  display: none;
`;

export const StyledNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-right: ${rem('16px')};
`;

export const StyledTitle = styled(Heading)`
  color: ${({ theme }) => theme.colors.cross.black};
  margin: 0 0 ${rem('8px')} 0;
  letter-spacing: ${rem('-0.48px')};
  line-height: ${rem('28px')};
  word-wrap: wrap;
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${rem('16px')};
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.lightGray};
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    padding-top: ${rem('16px')};
  }
`;
